import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';
import { ApiEndPoints } from 'src/app/api-end-points';

@Injectable({
  providedIn: 'root'
})
export class KycVerifyService {

  constructor(private http: HttpClient, private _apiEndPoints: ApiEndPoints) {
    Inject(ApiEndPoints)
  }

  public verifyKycDetails(body) {
    let myHeaders = new HttpHeaders();
    myHeaders.append('Accept', 'application/json');
    let options = {
      headers: myHeaders
    };
    let url = this._apiEndPoints.filteredEndPoints['generateLink'];
    return this.http.post(url, body, options).pipe(map(response => {
      return response;
    }));
  }
}